import { render, staticRenderFns } from "./cModalFreeBeds.vue?vue&type=template&id=07f6ecf4&scoped=true"
import script from "./cModalFreeBeds.vue?vue&type=script&lang=js"
export * from "./cModalFreeBeds.vue?vue&type=script&lang=js"
import style0 from "./cModalFreeBeds.vue?vue&type=style&index=0&id=07f6ecf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6ecf4",
  null
  
)

export default component.exports